import React, { Component } from 'react';
import {Divider, Paper, Chip, Avatar, Card, CardContent, CardActions, Drawer, TableRow, TableCell, Table, TableHead, Button, IconButton, Box, LinearProgress, Grid, Link, Container} from "@mui/material";
import { Apps, Done, Check, SupervisedUserCircle, Edit, ArrowBack } from "@mui/icons-material";
import EditTeamLeader from './EditTeamLeader';
import Api from "../../customlib/Api";
import axios from "axios";
import Global from '../../customlib/Global';
 
class TeamLeader extends Component {
    state = { 
        bottom: false,
        appProfiles: [],
        selectedAppProfile: null,
        defaultLeaderType: "",
        isLoading: false,
        standAlone: false
    }

    toggleDrawer = (anchor, open) => (event) => {
        console.log("TOGGLE", anchor, open);
        this.setState({ ...this.state, [anchor]: open });
    };

    loadTeamLeaderList = () => {

        let params = {
            appProfileId: Global.getAppProfile()._id,
            leaderType: this.state.defaultLeaderType
        };

        this.setState({isLoading: true}, () => {
            axios
                .post(Api.teamLeaderList(), params, Api.getRequestHeader())
                .then((response) => {
                    console.log(response);
                    this.setState({appProfiles: response.data.data, isLoading: false});
                })
                .catch((error) => {
                    this.setState({isLoading: false});
                    console.error("There was an error!", error);
                });
        });
    }

    componentDidMount(){

        let defaultType = this.props.defaultType;
        let standAlone = this.props.standAlone;
        this.setState({defaultLeaderType: defaultType ? defaultType : "", standAlone: standAlone ? standAlone : false}, () => {
            this.loadTeamLeaderList();
        });
    }

    render() { 
        return ( 
            <Container sx={{mt: "10px"}} maxWidth={"lg"}>

                <Paper elevation={3} sx={{mt: "20px", mb: "10px"}}>
                    <Box>
                        <Grid container spacing={1} justifyContent={"space-between"}>
                            <Grid item>
                                <Link href='/'>
                                    <IconButton color='primary'><ArrowBack /></IconButton>
                                </Link>
                            </Grid>
                            <Grid item>
                                <h3>Team Leader</h3>
                            </Grid>
                            <Grid item>
                                <Button variant='contained' color='primary' sx={{margin: "10px"}} startIcon={<SupervisedUserCircle />} 
                                    // onClick={this.toggleDrawer('bottom', true)}
                                    onClick={() => {this.setState({bottom: true, selectedAppProfile: null});}}
                                    >
                                    Tambah Team
                                </Button>
                            </Grid>
                        </Grid>
                        <Divider style={{marginTop: 10}} />
                        {
                            this.state.isLoading && <LinearProgress />
                        }
                        <div className="containera">
                            <Table size='small'>
                                <TableHead>
                                    <TableCell>Nama Team</TableCell>
                                    <TableCell>Nama Leader</TableCell>
                                    <TableCell>Tipe Team</TableCell>
                                    <TableCell align='right'>Jumlah Member</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell align='center'>Action</TableCell>
                                </TableHead>
                                {
                                    this.state.appProfiles.map(item => {
                                        return <TableRow>
                                            <TableCell>{item.teamLeaderName}</TableCell>
                                            <TableCell>{item.leaderName}</TableCell>
                                            <TableCell>{item.leaderType}</TableCell>
                                            <TableCell align='right'>{item.members?.length}</TableCell>
                                            <TableCell>{item.isTeamEnabled ? "ACTIVE" : "INACTIVE"}</TableCell>
                                            <TableCell align='center'>
                                                <IconButton 
                                                    size='small' 
                                                    color='primary'
                                                    onClick={() => {
                                                        this.setState({bottom: true, selectedAppProfile: item});
                                                    }}
                                                    >
                                                    <Edit />
                                                </IconButton></TableCell>
                                        </TableRow>
                                    })
                                }

                            </Table>
                        </div>
                    </Box>
                </Paper>

                {['left', 'right', 'top', 'bottom'].map((anchor) => (
                    <React.Fragment key={anchor}>
                        {/* <Button onClick={this.toggleDrawer(true)}>{anchor}</Button> */}
                        <Drawer 
                            anchor={anchor} 
                            open={this.state[anchor]} 
                            onClose={this.toggleDrawer('bottom',false)}
                        >
                            {/* <TemplateMessage onCloseDrawer={() => {this.setState({right: false});}} pushMessageHandler={this.handlePushMessage} messageData={this.handleGetMessageData} onClose={this.toggleDrawer('right',false)}/> */}
                            <EditTeamLeader data={this.state.selectedAppProfile} onReload={this.loadTeamLeaderList} onClose={this.toggleDrawer('bottom',false)} />
                        </Drawer>
                    </React.Fragment> 
                ))}
            </Container>
         );
    }
}
 
export default TeamLeader;